import React from "react";
import { Typography, Box } from "@mui/material";
import { vendorMainColumnMaxWidthSx } from "../../config/vendorContentMaxWidth";

const PrivacyPolicy = () => {
  return (
    <Box sx={{ width: "100%", py: 1, ...vendorMainColumnMaxWidthSx }}>
      <Box sx={{ textAlign: "center", marginBottom: "20px" }}>
        <Typography variant="h4" fontWeight="bold" color="#0b3d87">
          Privacy & Cookie Policy
        </Typography>
      </Box>

      <Typography variant="body1" paragraph>
        La tua privacy è importante per noi. Questa Privacy Policy descrive come raccogliamo, utilizziamo e proteggiamo i tuoi dati personali.
      </Typography>

      <Typography variant="h6" fontWeight="bold">
        Raccolta Dati
      </Typography>
      <Typography variant="body2" paragraph>
        Raccogliamo informazioni quando visiti il nostro sito, effettui un acquisto o interagisci con noi in altri modi.
      </Typography>

      <Typography variant="h6" fontWeight="bold">
        Cookie
      </Typography>
      <Typography variant="body2" paragraph>
        Usiamo cookie per migliorare la tua esperienza utente e analizzare il traffico sul sito. Puoi gestire le tue preferenze sui cookie dal tuo browser.
      </Typography>

      <Typography variant="h6" fontWeight="bold">
        Contatti
      </Typography>
      <Typography variant="body2" paragraph>
        Se hai domande sulla nostra politica sulla privacy, contattaci all'email: wowcheprezzi@majorbit.com.
      </Typography>
    </Box>
  );
};

export default PrivacyPolicy;
